import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function PeterGathingsPage() {
  return <AttorneyBioTemplate attorney={attorneys['peter-gathings-esq']} />;
}
